export const gitCommit = '7b383421'
